module.exports = __webpack_public_path__ + "static/media/unlimitedGamesPlayed_500000_1000000.1cbbb1c5.png";